export function setPageMeta(title, description) {
  document.title = title;
  
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    document.head.appendChild(metaDescription);
  }
  metaDescription.setAttribute('content', description);
}

export const HOMEPAGE_META = {
  title: 'Mood Food Recommender – Find What to Eat Based on Your Mood',
  description: 'Not sure what to eat? Pick your mood and discover food ideas that match how you feel. Find comfort foods, snacks, and quick meals for stress, sadness, or low energy.'
};
